import { apiClient } from "../lib/apiClient";

export const getDashboardStats = async (storeId: string) => {
  const response = await apiClient.get(
    `/api/v1/admin/${storeId}/analytics/dashboard`,
  );
  return response.data;
};

export const getUnifiedDashboard = async (storeId: string) => {
  const response = await apiClient.get(
    `/api/v1/admin/${storeId}/analytics/dashboard`,
  );
  return response.data;
};

export const getDashboardPanel = async (storeId: string, panel: string) => {
  const response = await apiClient.get(
    `/api/v1/admin/${storeId}/analytics/dashboard/${panel}`,
  );
  return response.data;
};
